import script from "./HTPickGameSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./HTPickGameSetting.vue?vue&type=script&setup=true&lang=js"

import "./HTPickGameSetting.vue?vue&type=style&index=0&id=eb7ac698&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb7ac698"]])

export default __exports__